import { getRenderTimeZone } from "@clockwise/web-commons/src/util/time-zone.util";
import { DateTime } from "luxon";

export const isDefaultTimeRange = (interval: string) => {
  const [start, end] = interval.split("/");
  const timeZone = getRenderTimeZone();
  const today = DateTime.local().setZone(timeZone);
  const defaultRangeEndDate = DateTime.now().set({ weekday: 6 }).plus({ week: 1 });

  const startDate = DateTime.fromISO(start, { setZone: true });
  const endDate = DateTime.fromISO(end, { setZone: true });

  if (startDate.hasSame(today, "day")) {
    return defaultRangeEndDate.hasSame(endDate, "day");
  }
  return false;
};
